import script from "./Admin-Client-List.vue?vue&type=script&setup=true&lang=js"
export * from "./Admin-Client-List.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__